import { render, staticRenderFns } from "./AttachmentsFormPage.vue?vue&type=template&id=7484ae44&"
import script from "./AttachmentsFormPage.vue?vue&type=script&lang=js&"
export * from "./AttachmentsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports